// Same breakpoint as $trade-modal-mobile: below it the modals are bottom sheets
export const TRADE_MODAL_MOBILE_QUERY = "(max-width: 768px)";

// Fields of the user with the "Don't ask again" choices
export const CONFIRM_SKIP_FLAG = {
  CASH_OUT: "skip_cash_out_confirm",
  CLOSE_ALL: "skip_close_all_confirm",
};
